// Create our initial value...
const popSocket2 = {
  document: {
    nodes: [
      {
        object: 'block',
        type: 'paragraph',
        data: { topkey: 'top' },
        nodes: [
          {
            object: 'inline',
            type: 'string',
            data: { ukey: 'text' },
            nodes: [
              {
                object: 'text',
                leaves: [
                  {
                    text: 'Into ',
                  },
                ],
              },
            ],
          },
          {
            object: 'inline',
            type: 'synonym',
            data: { ukey: 'synonym1' },
            nodes: [
              {
                object: 'text',
                leaves: [
                  {
                    text: ' synonym1 ',
                  },
                ],
              },
            ],
          },
          {
            object: 'inline',
            type: 'string',
            data: { ukey: 'text' },
            nodes: [
              {
                object: 'text',
                leaves: [
                  {
                    text: ', ',
                  },
                ],
              },
            ],
          },
          {
            object: 'inline',
            type: 'synonym',
            data: { ukey: 'synonym2' },
            nodes: [
              {
                object: 'text',
                leaves: [
                  {
                    text: ' synonym2 ',
                  },
                ],
              },
            ],
          },
          {
            object: 'inline',
            type: 'string',
            data: { ukey: 'text' },
            nodes: [
              {
                object: 'text',
                leaves: [
                  {
                    text: ' or ',
                  },
                ],
              },
            ],
          },
          {
            object: 'inline',
            type: 'synonym',
            data: { ukey: 'synonym3' },
            nodes: [
              {
                object: 'text',
                leaves: [
                  {
                    text: ' synonym3 ',
                  },
                ],
              },
            ],
          },
          {
            object: 'inline',
            type: 'string',
            data: { ukey: 'text' },
            nodes: [
              {
                object: 'text',
                leaves: [
                  {
                    text:
                      ', this one will be a big hit for birthday or any day! Teens, tweens, hipsters, and students will appreciate this clever PopSocket design.',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
}

export default popSocket2
